import { combineReducers, configureStore } from "@reduxjs/toolkit";
import CourseReducer from "./courseSlice";
import LecturerReducer from "./lecturerSlice";
import cartReducer from "./cartSlice";
import customerReducer from "./customerSlice";
import orderReducer from "./orderSlice";
import mailReducer from "./mailSlice";
import authReducer from "./authSlice";
import listorderReducer from "./newOrderSlice";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
}
const rootReducer = combineReducers({
    courses: CourseReducer,
    lecturers:LecturerReducer,
    cart: cartReducer,
    order:orderReducer,
    customer:customerReducer,
    auth: authReducer,
    listOrder: listorderReducer,
    sendMail :mailReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})

export let persistor = persistStore(store)
